import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLemon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 89,
	height: 88,
	viewBox: "0 0 89 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 5,
			width: 78,
			height: 78,
			rx: 39,
			fill: "#FFF8D5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.0823 54.2501C86.2088 62.0962 82.1918 69.2767 76.4736 75.0013C70.7553 80.7258 63.5575 84.7724 55.6725 86.6956C50.4586 87.9605 45.0619 88.3091 39.7269 87.7256C28.9852 86.478 19.05 81.4465 11.7249 73.5445C4.33159 65.6352 0.154578 55.2837 0.00185143 44.4925C-0.0720169 36.4538 2.0658 28.5477 6.18468 21.6272C10.3036 14.7068 16.2471 9.03475 23.3739 5.22323C28.0989 2.73842 33.232 1.10971 38.5324 0.413454C43.8275 -0.294412 49.2057 -0.0921811 54.4317 1.01125C59.6777 2.11338 64.6748 4.16459 69.1735 7.06255C78.2961 12.9301 84.9426 21.9091 87.86 32.3071V32.3071C88.0545 33.0428 88.2304 33.7602 88.4156 34.4591C88.5562 35.1458 88.6582 35.8397 88.7212 36.5376C88.7953 37.1997 88.8509 37.8434 88.9064 38.4504C88.9064 38.7447 88.9064 39.039 88.9712 39.3241C89.036 39.6092 88.9712 39.8851 88.9712 40.1518C88.8601 42.267 88.6101 43.6465 88.2582 43.8304C87.9063 44.0143 87.5174 43.0211 87.1748 41.283C87.0822 40.8415 86.9989 40.3633 86.9248 39.8391C86.8507 39.3149 86.6748 38.7723 86.5636 38.1837C86.4525 37.5951 86.3044 36.9698 86.184 36.3444C86.1192 36.0225 86.0729 35.6914 85.9895 35.3512L85.7117 34.3396C85.6006 33.8889 85.471 33.4199 85.3506 32.9509C82.7439 23.0607 76.6442 14.4307 68.1642 8.63518C63.9268 5.7227 59.1732 3.63208 54.1539 2.47347C49.118 1.31958 43.9135 1.07966 38.7917 1.76532C28.4416 3.12705 18.9786 8.28385 12.262 16.2223C8.92639 20.135 6.3262 24.6113 4.5855 29.4378C2.85299 34.259 1.99094 39.3461 2.03902 44.465C2.14903 54.8075 6.04251 64.7573 12.9935 72.4593C19.9563 80.2074 29.577 85.0996 39.9769 86.1806C45.1171 86.6615 50.3024 86.235 55.2928 84.9206C60.246 83.5935 64.9191 81.3944 69.0902 78.4279C77.512 72.4899 83.4437 63.6859 85.758 53.6891C86.1284 52.4384 86.2951 51.1968 86.5266 50.0657C86.6377 49.4955 86.7581 48.9529 86.8785 48.4378C86.9989 47.9228 87.0266 47.4447 87.1192 46.994C87.4155 45.2099 87.7674 44.0143 88.11 43.8856C88.4526 43.7568 88.7027 44.7224 88.8416 46.433C88.9948 48.7353 88.8233 51.0476 88.3323 53.3029L88.2767 53.542L88.0823 54.2501Z",
			fill: "#173962"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 44.0017,
			cy: 59.4716,
			rx: 23.8142,
			ry: 5.52829,
			fill: "#002864",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.9669 39.409C48.8854 37.1451 49.2822 34.3516 51.1573 32.4765C53.0324 30.6014 55.8259 30.2046 58.0897 31.2859C59.1711 33.5498 58.7743 36.3434 56.8992 38.2185C55.0242 40.0935 52.2307 40.4903 49.9669 39.409Z",
			fill: "#6ED278"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9942 39.409L49.2962 39.7424C49.3725 39.9021 49.5012 40.0307 49.6608 40.107L49.9942 39.409ZM58.117 31.2859L58.815 30.9525C58.7388 30.7928 58.6101 30.6642 58.4504 30.5879L58.117 31.2859ZM50.6923 39.0755C49.7477 37.0982 50.0956 34.6595 51.7317 33.0235L50.6377 31.9295C48.5235 34.0436 48.0779 37.192 49.2962 39.7424L50.6923 39.0755ZM51.7317 33.0235C53.3677 31.3874 55.8063 31.0395 57.7836 31.984L58.4504 30.5879C55.9001 29.3697 52.7517 29.8154 50.6377 31.9295L51.7317 33.0235ZM57.419 31.6194C58.3636 33.5967 58.0156 36.0354 56.3796 37.6714L57.4736 38.7655C59.5877 36.6513 60.0334 33.5029 58.815 30.9525L57.419 31.6194ZM56.3796 37.6714C54.7435 39.3075 52.3049 39.6554 50.3277 38.7109L49.6608 40.107C52.2112 41.3252 55.3595 40.8795 57.4736 38.7655L56.3796 37.6714Z",
			fill: "#153862"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M47.0948 23.0264C50.2496 24.1414 52.5099 27.1502 52.5099 30.6868C52.5099 34.2235 50.2496 37.2322 47.0948 38.3473C43.94 37.2322 41.6797 34.2235 41.6797 30.6868C41.6797 27.1502 43.94 24.1414 47.0948 23.0264Z",
			fill: "#6ED278"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.1221 23L47.3799 22.2706C47.2131 22.2117 47.0311 22.2117 46.8643 22.2706L47.1221 23ZM47.1221 38.3209L46.8643 39.0503C47.0311 39.1092 47.2131 39.1092 47.3799 39.0503L47.1221 38.3209ZM46.8643 23.7294C49.7197 24.7386 51.7636 27.4618 51.7636 30.6604L53.3108 30.6604C53.3108 26.7858 50.8341 23.4915 47.3799 22.2706L46.8643 23.7294ZM51.7636 30.6604C51.7636 33.8591 49.7197 36.5823 46.8643 37.5915L47.3799 39.0503C50.8341 37.8294 53.3108 34.5351 53.3108 30.6604L51.7636 30.6604ZM47.3799 37.5915C44.5245 36.5823 42.4806 33.8591 42.4806 30.6604L40.9334 30.6604C40.9334 34.5351 43.4101 37.8294 46.8643 39.0503L47.3799 37.5915ZM42.4806 30.6604C42.4806 27.4618 44.5245 24.7386 47.3799 23.7294L46.8643 22.2706C43.4101 23.4915 40.9334 26.7858 40.9334 30.6604L42.4806 30.6604Z",
			fill: "#153862"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.2009 56.531C54.0872 51.6447 54.9802 44.0662 52.1801 37.0987C52.8332 36.1918 52.7518 34.9196 51.9359 34.1037C51.12 33.2878 49.8478 33.2064 48.9408 33.8595C41.9734 31.0594 34.3949 31.9524 29.5086 36.8387C24.6223 41.725 23.7293 49.3034 26.5294 56.2709C25.8763 57.1779 25.9577 58.4501 26.7736 59.266C27.5895 60.0819 28.8617 60.1633 29.7687 59.5102C36.7361 62.3103 44.3146 61.4173 49.2009 56.531Z",
			fill: "#F6DD64"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.0799 32.918C48.7794 41.1933 47.4087 49.8914 41.6613 55.6388C39.2634 58.0367 36.352 59.6727 33.1719 60.5692C39.1175 61.9218 45.1212 60.6349 49.2255 56.5306C54.1118 51.6443 55.0048 44.0658 52.2048 37.0983C52.8578 36.1914 52.7764 34.9192 51.9605 34.1033C51.1446 33.2874 49.8724 33.206 48.9655 33.8591C48.0122 33.476 47.0475 33.162 46.0799 32.918Z",
			fill: "#DFBF23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.2009 56.531C54.0872 51.6447 54.9802 44.0662 52.1801 37.0987C52.8332 36.1918 52.7518 34.9196 51.9359 34.1037C51.12 33.2878 49.8478 33.2064 48.9408 33.8595C41.9734 31.0594 34.3949 31.9524 29.5086 36.8387C24.6223 41.725 23.7293 49.3034 26.5294 56.2709C25.8763 57.1779 25.9577 58.4501 26.7736 59.266C27.5895 60.0819 28.8617 60.1633 29.7687 59.5102C36.7361 62.3103 44.3146 61.4173 49.2009 56.531Z",
			stroke: "#153862",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.5876 36.9248C34.1968 37.598 30.7513 41.0435 30.0781 45.4342",
			stroke: "white",
			strokeWidth: 1.54717,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.7923 49.6887C61.7923 57.4245 55.6542 60.9056 48.6392 60.9056C43.9578 60.9056 44.8394 55.8836 44.8394 49.6887C44.8394 43.4937 43.9578 38.4717 48.6392 38.4717C54.7773 38.4717 61.7923 40.7924 61.7923 49.6887Z",
			fill: "#F6DD64"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M61.5427 47.6143C60.4989 54.097 53.7351 57.038 46.0932 57.038C45.6037 57.038 45.1655 56.9989 44.7734 56.9234C45.0463 59.3591 45.9309 60.9059 48.529 60.9059C55.544 60.9059 61.6821 57.4248 61.6821 49.6889C61.6821 48.9532 61.6341 48.2624 61.5427 47.6143Z",
			fill: "#DFBF23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.7925 49.6887C61.7925 57.8113 55.3754 60.9056 48.0415 60.9056C43.1473 60.9056 44.069 55.8836 44.069 49.6887C44.069 43.4937 43.1473 38.4717 48.0415 38.4717C54.4586 38.4717 61.7925 41.566 61.7925 49.6887Z",
			stroke: "#153862",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.4825,
			cy: 49.6887,
			rx: 10.4434,
			ry: 11.217,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.482,
			cy: 49.6882,
			rx: 8.12264,
			ry: 8.89623,
			fill: "#FFE361"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M47.1224 38.2783C47.0229 38.2783 46.9423 38.3649 46.9423 38.4717V46.2848C46.9423 46.7292 46.6239 47.0993 46.2439 47.3299C45.8391 47.5757 45.3225 47.6793 44.92 47.4297L38.7084 43.5777C38.6222 43.5243 38.5121 43.556 38.4624 43.6485L38.1023 44.3185C38.0526 44.411 38.0821 44.5293 38.1682 44.5827L44.3727 48.4302C44.7901 48.689 44.9617 49.1976 44.9617 49.6887C44.9617 50.1798 44.7901 50.6884 44.3727 50.9472L38.1682 54.7947C38.0821 54.8481 38.0526 54.9664 38.1023 55.0589L38.4624 55.7289C38.5121 55.8214 38.6222 55.853 38.7084 55.7996L44.92 51.9477C45.3225 51.6981 45.8391 51.8017 46.2439 52.0475C46.6239 52.2781 46.9423 52.6482 46.9423 53.0926V60.9057C46.9423 61.0125 47.0229 61.0991 47.1224 61.0991H47.8426C47.942 61.0991 48.0227 61.0125 48.0227 60.9057V53.0926C48.0227 52.6482 48.3411 52.2781 48.721 52.0475C49.1259 51.8017 49.6425 51.6981 50.045 51.9477L56.2567 55.7996C56.3428 55.8531 56.4529 55.8214 56.5026 55.7289L56.8628 55.0589C56.9125 54.9664 56.883 54.8481 56.7969 54.7947L50.5922 50.9471C50.1749 50.6883 50.0033 50.1798 50.0033 49.6887C50.0033 49.1976 50.1749 48.6891 50.5922 48.4303L56.7969 44.5827C56.883 44.5293 56.9125 44.411 56.8628 44.3185L56.5026 43.6485C56.4529 43.556 56.3428 43.5243 56.2567 43.5777L50.045 47.4297C49.6425 47.6793 49.1259 47.5757 48.721 47.3299C48.3411 47.0993 48.0227 46.7292 48.0227 46.2848V38.4717C48.0227 38.3649 47.942 38.2783 47.8426 38.2783H47.1224ZM47.4826 50.8491C48.0793 50.8491 48.563 50.3295 48.563 49.6887C48.563 49.0478 48.0793 48.5283 47.4826 48.5283C46.886 48.5283 46.4023 49.0478 46.4023 49.6887C46.4023 50.3295 46.886 50.8491 47.4826 50.8491Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 47.4825,
			cy: 49.6887,
			rx: 10.4434,
			ry: 11.217,
			stroke: "#153862",
			strokeWidth: 1.54717,
			strokeLinejoin: "round"
		})
	]
});
export default SvgLemon;
